import React from "react";
import { Control, FieldValues, FieldPath } from "react-hook-form";

import LabeledControllerField from "@components/common/LabeledControllerField/LabeledControllerField";
import RichTextBox from "@components/common/RichTextBox";
import { Stack, Typography } from "@components/base";

interface RichTextControllerFieldProps<T extends FieldValues> {
  label: string;
  name: FieldPath<T>;
  control: Control<T>;
  disabled?: boolean;
  placeholder?: string;
}

const RichTextControllerField = <T extends FieldValues>({
  label,
  name,
  control,
  disabled = false,
  placeholder,
}: RichTextControllerFieldProps<T>): React.ReactElement => {
  return (
    <LabeledControllerField<T, FieldPath<T>>
      label={label}
      name={name}
      control={control}
      disabled={disabled}
      render={({ field, error }) => (
        <Stack>
          <RichTextBox
            value={field.value}
            onChange={field.onChange}
            placeholder={placeholder}
          />
          {error && (
            <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.75 }}>
              {error.message}
            </Typography>
          )}
        </Stack>
      )}
    />
  );
};

export default RichTextControllerField;
